import Nullstack from 'nullstack';
export default function IconCurrencyDollarCanadian({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-dollar-canadian",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), "   ", Nullstack.element("path", {
    d: "M10 18h-1a6 6 0 1 1 0 -12h1"
  }), "   ", Nullstack.element("path", {
    d: "M17 20v-2"
  }), "   ", Nullstack.element("path", {
    d: "M18 6v-2"
  }), " ");
}